import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { environment } from '../../../environments/environment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-doc-template',
  templateUrl: './doc-template.component.html',
  styleUrls: ['./doc-template.component.css'], // Fix the property name to `styleUrls`
})
export class DocTemplateComponent implements OnInit, OnChanges {
  env = environment;
  @Input() tempateData: any;
  @Input() userData: any;
  @Output() onPDFGenerated: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.generatePDF(); 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tempateData'] && !changes['tempateData'].firstChange) {
      this.generatePDF(); 
    }
  }

  get getName() {
    const names = [
      this.userData?.name,
      ...(this.tempateData?.members?.map((user: any) => user.name) || []),
    ];
  
    return [...new Set(names)].join(', ');
  }
  

  // stripHtml(htmlString: any) {
  //   const tempElement = document.createElement('div');
  //   tempElement.innerHTML = htmlString;
  //   return tempElement.textContent || tempElement.innerText || '';
  // }

  // get capabilities() {
  //   return this.stripHtml(this.tempateData?.capabilities);
  // }

  generatePDF(): void {
    const content = document.getElementById('pdf-content');
    if (content) {
      setTimeout(() => {
        html2canvas(content, {
          scale: 2,
          useCORS: true,
          logging: true,
        })
          .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');

            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

            // Emit event when PDF generation is completed
            this.onPDFGenerated.emit({ success: true });

            pdf.save('document.pdf');
          })
          .catch((error) => {
            this.onPDFGenerated.emit({ success: false, error });
          });
      }, 100);
    } else {
      this.onPDFGenerated.emit({ success: false, error: 'Content element not found' });
    }
  }
}
